import { useState } from "react";
import { useIdleTimer } from "react-idle-timer/dist/index.legacy.cjs";

import { logout } from "./helpers";

/**
 * @param onIdle - function to notify user when idle timeout is close
 * @param idleTime - number of seconds to wait before user is logged out
 */

const useIdleTimeout = ({ onIdle, idleTime, history, setShowIdleModal }) => {
  const idleTimeout = 1000 * idleTime;

  const [isIdle, setIdle] = useState(false);

  const handleIdle = () => {
    setIdle(true);
    logout(history);
    setShowIdleModal(false);
  };

  const idleTimer = useIdleTimer({
    timeout: idleTimeout,
    promptTimeout: idleTimeout - 120,
    onPrompt: onIdle,
    onIdle: handleIdle,
    debounce: 500,
  });
  return {
    isIdle,
    setIdle,
    idleTimer,
  };
  return {};
};
export default useIdleTimeout;
